import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, NavbarBrand } from 'reactstrap';

const Logout = ({ setIsAuthed }) => {
    useEffect(() => {
        const logoutUser = () => {
            localStorage.clear();
            setIsAuthed(false);
        };

        logoutUser();
        // eslint-disable-next-line
    }, []);

    return <>
        <Navbar expand="xs" className="mb-5">
            <Nav className="mx-auto">
                <NavbarBrand className="pb-3">
                    {/* <img src={`/img/logo.svg`} alt="logo" height="25rem" /> */}
                </NavbarBrand>
            </Nav>
        </Navbar >
        <div className="row">
            <div className="col-md-12 text-center mt-5 logoutText">
                <p>  ご利用いただきありがとうございます。</p><br />
                <Link to="/login" className="link__login mt-2"> 再度ログイン </Link>
            </div>
        </div>
    </>
}

export default Logout;
